<template>
	<div>
        <StellarNetwork  ref="stellar_network_modal"  :file=file></StellarNetwork>
        <FileDownload    ref="file_download_modal"    :file=file></FileDownload>
        <SourceEmail     ref="source_email_modal"     :file=file></SourceEmail>

        <!-- DESKTOP layout -->
        <div  v-if="$mq !== 'mobile'"  style="padding:5px;">
            <table class="table table-bordered table-condensed"  style="table-layout:fixed;">
                <thead>
                    <tr>
                        <th class="active text-left" style="width: 60px;">
                            <b>Status</b>
                        </th>
                        <th class="active text-left" style="width: 60px;">
                            <b>Source</b>
                        </th>
                        <th class="active text-left" style="width: 180px;">
                            <b>Timestamp</b>
                        </th>
                        <th class="active text-left">
                            <b>Filename</b>
                        </th>
                        <th class="active text-left">
                        </th>
                    </tr>
                </thead>
                <tbody v-if="show_files=='loading'"  class="text-center">
                    <tr>
                        <td  colspan=5>
                            &nbsp;<br>
                            <i class="fas fa-circle-notch fa-spin"></i>  Loading data...<br>
                            &nbsp;
                        </td>
                    </tr>
                </tbody>
                <tbody v-else-if="show_files=='no data'"  class="text-center">
                    <tr>
                        <td  colspan=5>
                            &nbsp;<br>
                            <b>No Files</b>  Once you have emailed an attachement to "protect@filedsafely.com" the files will appear here.<br>
                            &nbsp;
                        </td>
                    </tr>
                </tbody>
                <tbody v-else  class="text-center">
                    <tr  v-for="(file, index) in files"  :key="'fo-'+file.code+index"  style="overflow:hidden;">
                        <td  class="text-center">
                            <div v-if="file.status == 'filed'"  class="btn-link"  @click="show_stellar_network(file)">{{ file.status }}</div>
                            <div v-else>{{ file.status }}</div>
                        </td>
                        <td  class="text-center">
                            <div v-if="file.source == 'email'"  class="btn-link"  @click="show_source_email(file)">{{ file.source }}</div>
                            <div v-else >{{ file.source }}</div>
                        </td>
                        <td  class="text-left">
                            {{ file.timestamp | moment("Do MMM YYYY, HH:mm:ss") }}<br>
                            <small class="text-muted"><timeago :datetime=file.timestamp :auto-update="120"></timeago></small>
                        </td>
                        <td  class="text-left">
                            <div v-if="file.status == 'filed'">
                                <!--<a :href="axios.defaults.baseURL + 'api/files/' + file.code + '/download?api_token=' + api_token" target="_blank">{{ file.name }}</a>-->
                                <button class="btn btn-link text-break"  
                                        style="padding:0px;"
                                        @click="show_file_download(file)">{{ file.name }}</button>
                            </div>
                            <div v-else  class=""  style="word-wrap:break-word; overflow-wrap:break-word;">
                                {{ file.name }}
                            </div>
                        </td>
                        <td v-if="file.source == 'email'"
                            class="text-left" style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                            <small>
                                <span class="text-muted">subject: </span><b>{{ file.email_subject }}</b>,
                                <span class="text-muted">at: </span>{{ file.email_sent_at | moment("HH:mm:ss, Do MMM YYYY") }}
                            </small>
                            <br>
                            <small class="text-muted">to: </small>{{ file.email_to }}
                            <br>
                            <span  v-if="file.email_cc != ''">
                                <small class="text-muted">cc: </small>{{ file.email_cc }}
                            </span>
                        </td>
                        <td v-else-if="file.source == 'upload'"
                            class="text-left" style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                            <small class="text-muted">subject: </small><small><b>{{ file.upload_subject }}</b></small>
                            <br>
                            <small class="text-muted">at: </small><small>{{ file.uploaded_at | moment("HH:mm:ss, Do MMM YYYY") }}</small>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div v-if="1==2">
                <br>
                <i v-if="page_number > 1"          @click="get_users_files(1)"               class="fas fa-angle-double-left"></i>&nbsp;&nbsp;
                <i v-if="page_number > 1"          @click="get_users_files(page_number - 1)" class="fas fa-angle-left"></i>&nbsp;&nbsp;
                Page {{ page_number }} of {{ page_total }}&nbsp;&nbsp;
                <i v-if="page_number < page_total" @click="get_users_files(page_number + 1)" class="fas fa-angle-right"></i>&nbsp;&nbsp;
                <i v-if="page_number < page_total" @click="get_users_files(page_total)"      class="fas fa-angle-double-right"></i>
            </div>

            <div  v-if="files  &&  files.length > 0"
                  style="width:100%;
                         display:flex; justify-content:end; align-items:center;
                         clear:both;">
                <div style="margin-right:10px;">
                    Page {{ page_number }} of {{ page_total }}&nbsp;&nbsp;
                </div>
                <div style="margin-right:10px;">
                    <button  @click="get_users_files(page_number - 1)" 
                            :disabled="page_number == 1"
                            name="button"  type="submit"  
                            class="btn btn-small btn-primary"
                    >
                        <i class="fas fa-angle-left"></i>
                    </button>
                </div>
                <div style="margin-right:0px;">
                    <button  @click="get_users_files(page_number + 1)" 
                            :disabled="page_number == page_total"
                            name="button"  type="submit"  
                            class="btn btn-small btn-primary"
                    >
                        <i class="fas fa-angle-right"></i>
                    </button>
                </div>
            </div>
        </div>

        <!-- MOBILE layout -->
        <div  v-else                   style="padding:5px;">
            <table class="table table-bordered table-condensed"  style="table-layout:fixed;">
                <thead>
                    <tr>
                        <th class="active text-left" style="width: 60px;">
                            <b>Status</b>
                        </th>
                        <th class="active text-left" style="width: 60px;">
                            <b>Source</b>
                        </th>
                        <th class="active text-left">
                            <b>File</b>
                        </th>
                    </tr>
                </thead>
                <tbody v-if="show_files=='loading'"  class="text-center">
                    <tr>
                        <td  colspan=3>
                            &nbsp;<br>
                            <i class="fas fa-circle-notch fa-spin"></i>  Loading data...<br>
                            &nbsp;
                        </td>
                    </tr>
                </tbody>
                <tbody v-else-if="show_files=='no data'"  class="text-center">
                    <tr>
                        <td  colspan=3>
                            &nbsp;<br>
                            <b>No Files</b>  Once you have emailed an attachement to "protect@filedsafely.com" the files will appear here.<br>
                            &nbsp;
                        </td>
                    </tr>
                </tbody>
                <tbody v-else  class="text-center">

                    <template v-for="(file, index) in files">
                        <tr  :key="'fo1-'+file.code+index"  style="overflow:hidden;">
                            <td  class="text-center">
                                <div v-if="file.status == 'filed'"  class="btn-link"  @click="show_stellar_network(file)">{{ file.status }}</div>
                                <div v-else>{{ file.status }}</div>
                            </td>
                            <td  class="text-center">
                                <div v-if="file.source == 'email'"  class="btn-link"  @click="show_source_email(file)">{{ file.source }}</div>
                                <div v-else >{{ file.source }}</div>
                            </td>
                            <td  class="text-left">
                                <span  v-if="file.status == 'filed'"  class="btn-link"  @click="show_file_download(file)">{{ file.name }}</span>
                                <span  v-else >{{ file.name }}</span>
                                <br>
                                <small>{{ file.timestamp | moment("HH:mm:ss, Do MMM YYYY") }}</small>
                            </td>
                        </tr>
                    </template>

                </tbody>
            </table>

            <div  v-if="files  &&  files.length > 0"
                  style="width:100%;
                         display:flex; justify-content:end; align-items:center;
                         clear:both;">
                <div style="margin-right:10px;">
                    Page {{ page_number }} of {{ page_total }}&nbsp;&nbsp;
                </div>
                <div style="margin-right:10px;">
                    <button  @click="get_users_files(page_number - 1)" 
                            :disabled="page_number == 1"
                            name="button"  type="submit"  
                            class="btn btn-small btn-primary"
                    >
                        <i class="fas fa-angle-left"></i>
                    </button>
                </div>
                <div style="margin-right:0px;">
                    <button  @click="get_users_files(page_number + 1)" 
                            :disabled="page_number == page_total"
                            name="button"  type="submit"  
                            class="btn btn-small btn-primary"
                    >
                        <i class="fas fa-angle-right"></i>
                    </button>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
    import EventBus        from '@/event_bus';					// Event Bus
    import StellarNetwork  from '@/components/modals/stellar_network.vue';
    import FileDownload    from '@/components/modals/file_download.vue';
    import SourceEmail     from '@/components/modals/source_email.vue';

    export default {
        components: {
            EventBus,
            StellarNetwork,
            FileDownload,
            SourceEmail,
        },

        data() {
            return {
                file_id:       '',
                file:          '',

                explorer_link: '',
				show_files:    'loading',
                files:         [],
				page_total:    0,
				page_number:   1,
				page_rows:     12,
            };
        },

        computed: {
        },
		
		created() {
            if (process.env.VUE_APP_ENV != "production") {
                this.explorer_link = 'https://testnet.steexp.com/tx/';
            }
            else {
                this.explorer_link = 'https://steexp.com/tx/';
            }
		},

        mounted() {
			if (this.is_logged_in()) {
				this.get_users_files(1);
			}
        },
		
        methods: {
			is_logged_in() {
				var status     = false;
				this.api_token = localStorage.getItem('api_token');
				
				if (this.api_token  &&  this.api_token.length == 64) {
					status = true;
				}
					
				return status;
			},

            // Show Stellar Network modal
            show_stellar_network(file) {
                this.file   = file;
                let element = this.$refs.stellar_network_modal.$el;
                $(element).modal('show');
            },
    
            // Show File Download modal
            show_file_download(file) {
                this.file   = file;
                let element = this.$refs.file_download_modal.$el;
                $(element).modal('show');
            },
    
            // Show Source Email modal
            show_source_email(file) {
                this.file   = file;
                let element = this.$refs.source_email_modal.$el;
                $(element).modal('show');
            },
    
            // Get Users Files
            get_users_files(page) {
				let vm = this;
				var files;
				
				vm.show_files = 'loading';

				// Call API for files
				const post_data = {
					api_token:   this.api_token,
					page_rows:   this.page_rows,
					page_number: page,
				};

				this.axios.post('api/files_owned', post_data)
				.then(response => {
                    vm.files       = response.data.records;
                    vm.page_total  = response.data.pagination.page_total;
                    vm.page_number = response.data.pagination.page_number;

                    if (vm.files.length == 0) {
                        vm.show_files = "no data";
                    }
                    else {
                        vm.show_files = "true";
                    }
				})
				.catch(error => {
					var error_msg = '';
					if (error.response) {
                        if (error.response.data.message) {
                            error_msg = error_msg + error.response.data.message + "<br>";	
                        }

                        if (error.response.data.error) {
                            Object.keys(error.response.data.error).forEach(key => {
                                error_msg = error_msg + error.response.data.error[key] + "<br>";

                                // load api errors into client errors
                                this.errors.add({
                                    field: key,
                                    msg:   error.response.data.error[key],
                                });
                            });
                        }

                        this.$notify({
                            group: "fs_danger",
                            title: "Error",
                            text: error_msg,
                            type: "error"
                        });
                    }
                    else if (error.message == "Network Error") {
                        localStorage.removeItem('api_token');
				        this.$store.commit("RESET");
                        this.api_token = null;

                        this.$notify({
                            group: "fs_warning",
                            title: "Session has expired",
                            text:  "Please log in again.",
                            type:  "error"
                        });

                        EventBus.$emit('refresh_header_api_token', this.api_token);
                        this.$router.push({'name': 'home'});
                    }
                    else {
                        this.$notify({
                            group: "fs_danger",
                            title: "Error",
                            text: "Unexpected error.<br>Suggest logging out and back in again.",
                            type: "error"
                        });
                    }
				});
			},
        }
    };
</script>
